import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { api, ApiError } from '../api';
import { useSession } from '../session';

export function MfaResetComplete() {
  const { token = '' } = useParams();
  const { refresh } = useSession();
  const navigate = useNavigate();
  const [email, setEmail] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api<{ email: string }>(`/api/mfa-reset/${encodeURIComponent(token)}`)
      .then((r) => setEmail(r.email))
      .catch((err) => setError(err instanceof ApiError ? err.message : 'This link could not be checked'));
  }, [token]);

  async function complete() {
    setBusy(true);
    setError(null);
    try {
      await api(`/api/mfa-reset/${encodeURIComponent(token)}/complete`, { method: 'POST' });
      await refresh();
      navigate('/enrol', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'The reset could not be completed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="card narrow">
      <h1>Reset your sign-in</h1>
      {error && <div className="alert">{error}</div>}
      {email && !error && (
        <>
          <p className="lede">An owner has verified you. Continuing removes every authenticator and passkey from {email} and signs out all sessions. You will then set up new ones.</p>
          <button type="button" className="block" onClick={complete} disabled={busy}>
            {busy ? 'Removing…' : 'Remove old factors and continue'}
          </button>
        </>
      )}
      {!email && !error && <p className="muted">Checking the link…</p>}
      <p className="small muted" style={{ marginTop: 20, marginBottom: 0 }}><Link to="/login">Back to sign in</Link></p>
    </div>
  );
}
